/**
 * B&Y APPLICATION FRONTEND
 * (c) 2020 B&Y
 */

/**
 * JUPITER IMPORTS
 */
import {
  Application,
  Cookies,
  Dom,
  Events,
  Links,
  // HeroVideo,
  // Moonwalk,
  gsap
} from '@univers-agency/jupiter'

/**
 * APP SPECIFIC MODULE IMPORTS
 */

// import SmartVideo from './modules/SmartVideo'
import Parade from './modules/Parade'
import Confetti from './modules/Confetti'
import Popups from './modules/Popups'

/**
 * CONFIG IMPORTS
 */
import configureBreakpoints from './config/BREAKPOINTS'
// import configureMoonwalk from './config/MOONWALK'
// import configureHero from './config/HERO_VIDEO'


import '../css/app.pcss'

const app = new Application({
  respectReducedMotion: false,
  breakpointConfig: configureBreakpoints,
  bindScroll: false,
  faderOpts: {
    fadeIn: () => {}
  }
})

app.registerCallback(Events.APPLICATION_READY, () => {
  const $loader = Dom.find('#loader')
  app.links = new Links(app)
  gsap.to('.status__text', { opacity: 1, delay: 1, stagger: 1 })
  gsap.to('#loader div', {
    xPercent: gsap.utils.wrap([100, -100]),
    ease: 'power2.in',
    stagger: 0.1,
    delay: 4,
    onComplete: () => {
      Dom.removeClass($loader, 'active')
      gsap.to('#loader', { display: 'none' })
      app._emitRevealedEvent()
      // check size
    }
  })
  if (app.featureTests.results.ios) {
    setTimeout(() => {
      app.setDims()
    }, 2000)
  }
})

app.registerCallback(Events.APPLICATION_PRELUDIUM, () => {
  app.cookies = new Cookies(app)
  app.parade = new Parade(app)
  app.confetti = new Confetti(app)
  app.popups = new Popups(app)
})

// trigger ready state
if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
  app.initialize()
} else {
  document.addEventListener('DOMContentLoaded', app.initialize.apply(app))
}

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
  module.hot.accept()
}
